export enum EnumModuleTypes {
    basic = 'basic',
    additional = 'additional'
}